// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import qs from 'qs';
import { setCookie, delCookie, getCookie } from './cookie/cookie'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css';
import { Tab, Tabs } from 'vant';
import 'vant/lib/index.css';
Vue.use(Tab).use(Tabs);
import Home from './components/home';
import Software from './components/Features/Software';
import Hardware from './components/Features/Hardware'
import Products from './components/Product/Product';
import Blog from './components/Blog/Blog';
import BlogDetail from './components/Blog/BlogDetail';
import Contact from './components/Contact/Contact';
import About from './components/About/About';
import FAQ from './components/Faq/Faq';
// 移动端
import mHome from './components/mobile/home';
import mSoftware from './components/mobile/Features/Software';
import mHardware from './components/mobile/Features/Hardware';
import mProducts from './components/mobile/Product/Product';
import mBlog from './components/mobile/Blog/Blog';
import mBlogDetail from './components/mobile/Blog/BlogDetail';
import mContact from './components/mobile/Contact/Contact';
import mAbout from './components/mobile/About/About';
import mFAQ from './components/mobile/Faq/Faq';

const routes = [
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/Software',
    name: 'Software',
    component: Software
  },
  {
    path: '/Hardware',
    name: 'Hardware',
    component: Hardware
  },
  {
    path: '/Products',
    name: 'Products',
    component: Products
  },
  {
    path: '/Blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/BlogDetail',
    name: 'BlogDetail',
    component: BlogDetail
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/About',
    name: 'About',
    component: About
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ
  },

// 移动端
  {
    path: '/mHome',
    name: 'mHome',
    component: mHome
  },
  {
    path: '/mSoftware',
    name: 'mSoftware',
    component: mSoftware
  },
  {
    path: '/mHardware',
    name: 'mHardware',
    component: mHardware
  },
  {
    path: '/mProducts',
    name: 'mProducts',
    component: mProducts
  },
  {
    path: '/mBlog',
    name: 'mBlog',
    component: mBlog
  },
  {
    path: '/mBlogDetail',
    name: 'mBlogDetail',
    component: mBlogDetail
  },
  {
    path: '/mContact',
    name: 'mContact',
    component: mContact
  },
  {
    path: '/mAbout',
    name: 'mAbout',
    component: mAbout
  },
  {
    path: '/mFAQ',
    name: 'mFAQ',
    component: mFAQ
  },
]
const router = new VueRouter({
  routes,
  mode:'history'
  // base:'/lettuce/'
});


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.use(VueI18n);
Vue.use(VueRouter)
Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$setCookie = setCookie;
Vue.prototype.$delCookie = delCookie;
Vue.prototype.$getCookie = getCookie;

const i18n = new VueI18n({
  locale: getCookie('PLAY_LANG', 'EN'),// 语言标识
  messages: {
    'ZH': require('./langs/zh'),
    'EN': require('./langs/en'),
    'PH': require('./langs/en'),
    'MA': require('./langs/en')
  },
  silentTranslationWarn: true
});
if (getCookie('langs') === 'ZH') {
  i18n.locale = 'ZH';
} else {
  i18n.locale = 'PH';
}



router.beforeEach((to, from, next) => {
   let to_path = to.path.toLocaleLowerCase().split('/')[1].split('?')[0]; // 路由去往
   let from_path = from.path.toLocaleLowerCase().split('/')[1].split('?')[0]; // 路由去往

  if (to_path===''){
      next({
        path: '/Home',
      });
   }else{
     next();
   }
})
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  setCookie,
  delCookie,
  getCookie,
  render: h => h(App)
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js